import UILayout from "components/layout/UILayout";
import Breadcrumbs from "components/shared/Breadcrumbs";
import PaydayTimeline from "components/shared/PaydayTimeline";
import DisappearingTile from "components/ui/DisappearingTile";
import styled from "styled-components";

const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TimelineWrapper = styled.div`
  max-width: 320px;
  margin: 0 auto;
`;

const Payday = () => {
  return (
    <Wrapper>
      <Breadcrumbs />

      <DisappearingTile size="xl">
        <TimelineWrapper>
          <PaydayTimeline />
        </TimelineWrapper>
      </DisappearingTile>
    </Wrapper>
  );
};

export default Payday;
